import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dataUtils from "../../../../../../common/utils/dataUtils";
import ItemStatus from "../../../../../../common/components/item_status";

type Props = {
  onActionEditar: (idProjeto: number | null, openState: boolean) => void;
  onActionDeletar: (idProjeto: number | null, openState: boolean) => void;
  onActionEnviarEmail: (idProjeto: number | null, openState: boolean) => void;
};

export const GenerateProjetoColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionEnviarEmail,
}: Props): GridColDef[] => {
  const computeItemStatusColor = (status: string) => {
    switch (status) {
      case "EA":
        return "yellow";
      case "AT":
        return "red";
      case "CD":
        return "green";
      case "CA":
        return "blue"; // azul claro
      case "NI":
        return "gray"; // cinza claro
      case "NA":
        return "gray"; // cinza médio
      default:
        return "gray";
    }
  };

  const computeItemStatusTiitle = (status: string) => {
    switch (status) {
      case "EA":
        return "EA";
      case "AT":
        return "AT";
      case "CD":
        return "CD";
      case "CA":
        return "CA";
      case "NI":
        return "NI";
      case "NA":
        return "NA";
      default:
        return "NA";
    }
  };
  const computeItemStatusDescription = (status: string) => {
    switch (status) {
      case "EA":
        return "Em Andamento";
      case "AT":
        return "Atrasado";
      case "CD":
        return "Concluído Dentro do Prazo";
      case "CA":
        return "Concluído Com Atraso";
      case "NI":
        return "Não Foi Iniciado";
      case "NA":
        return "Data Não Informada";
      default:
        return "Data Não Informada";
    }
  };

 return [
    {
      field: "Status",
      filterable: false,
      headerName: "Status",
      width: 80, 
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTiitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "DescricaoProjeto",
      headerName: "Projeto",
      flex: 1, 
      minWidth: 250,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
      renderCell: (params) => {
        return (
          <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Responsavel",
      headerName: "Responsável Pelo Projeto",
      flex: 1, 
      minWidth: 200,
      sortable: false,
      filterable: false,
      headerClassName: "responsavel-header",
      renderCell: (params) => {
        return (
          <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "CentroCustoNome",
      headerName: "Centro de Custo",
      flex: 1, 
      minWidth: 200,
      sortable: false,
      filterable: false,
      headerClassName: "centro-header",
      renderCell: (params) => {
        return (
          <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "DataInicio",
      headerName: "Data de Início Prevista",
      width: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{dataUtils.dataFormatada(params.value)}</span>
          </div>
        );
      },
      headerClassName: "data-header",
    },
    {
      field: "DataTermino",
      headerName: "Data de Término Prevista",
      width: 130, 
      sortable: false,
      filterable: false,
      headerClassName: "data-header",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{dataUtils.dataFormatada(params.value)}</span>
          </div>
        );
      },
    },
    {
      field: "IdProjeto",
      headerName: "Ações",
      width: 100, 
      sortable: false,
      filterable: false,
      renderCell: ( params ) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
    {
      field: 'email',
      sortable: false,
      filterable: false,
      headerName: 'Enviar Email',
      width: 90, // 👈 Levemente aumentado para garantir que o cabeçalho quebre bonitinho igual a imagem
      valueGetter: (_, row) => row['IdProjeto'] as number,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEnviarEmail(value, true)}>
              <DynamicIcon nameIcon="EmailOutlined" size={25} className="text-[#009C4E]" />
            </IconButton>
          </div>
        );
      }
    },
  ];

};
